import Enum from "../../../../enums/Enum";

const VisitCostingStatus = new Enum({
    NOT_GENERATED: {name: "Not Generated"},
    GENERATED: {name: "Generated"},
    SUBMITTED: {name: "Submitted"},
    REJECTED: {name: "Rejected"},
    RESUBMITTED: {name: "Resubmitted"}
});

export default VisitCostingStatus;
